import { combineEpics } from 'redux-observable';
import errorHandling from './errorHandling';

export const coreEpics = combineEpics(errorHandling);
